import DefaultLightTheme from "./default-light";
export const DefaultLight = DefaultLightTheme;
import DefaultDarkTheme from "./default-dark";
export const DefaultDark = DefaultDarkTheme;
import DefaultContrastTheme from "./default-contrast";
export const DefaultContrast = DefaultContrastTheme;
